<template>
  <section class="feed-month-lessons text-light">
    <div v-if="!hideMasterClass" class="px-4 px-lg-5">
      <h5 class="mb-4">
        <span class="badge">{{ number }}</span>
        GW {{ month.title }} – {{ month.subtitle }}
      </h5>
    </div>

    <div class="px-4 px-lg-5 d-md-none">
      <div class="d-flex flex-wrap">
        <lesson-slide
          v-for="(lesson, index) in month.lessons.filter(
            ls => !ls.is_month || hideMasterClass
          )"
          :key="index"
          :lesson="lesson"
        />
      </div>
    </div>

    <div class="position-relative d-none d-md-block">
      <div class="px-4 px-lg-5">
        <swiper :navigation="true" :breakpoints="breakpoints">
          <swiper-slide
            v-for="(lesson, index) in month.lessons.filter(
              ls => !ls.is_month || hideMasterClass
            )"
            :key="index"
          >
            <lesson-slide :lesson="lesson" />
          </swiper-slide>
        </swiper>
      </div>
    </div>

    <div
      v-if="masterclasses.length && !hideMasterClass"
      class="px-4 px-lg-5 mt-5"
    >
      <h5>Aulas</h5>
    </div>

    <div v-if="!hideMasterClass" class="position-relative">
      <div class="px-4 px-lg-5">
        <swiper :navigation="true" :breakpoints="masterclassBreakpoints">
          <swiper-slide v-for="(lesson, index) in masterclasses" :key="index">
            <lesson-slide :lesson="lesson" />
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </section>
</template>

<script>
import Swiper from "@/components/Swiper";
import SwiperSlide from "@/components/SwiperSlide";
import LessonSlide from "@/components/home/LessonSlide";
import { breakpoints } from "@/functions/helpers.js";

export default {
  components: { LessonSlide, Swiper, SwiperSlide },
  props: {
    month: {
      type: Object,
      default: () => ({})
    },
    number: {
      type: Number,
      default: 1
    },
    hideMasterClass: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      breakpoints,
      masterclassBreakpoints: {
        768: {
          slidesPerView: 2
        },
        992: {
          slidesPerView: 3
        },
        1200: {
          slidesPerView: 4
        },
        1600: {
          slidesPerView: 5
        }
      }
    };
  },
  computed: {
    masterclasses() {
      return this.month.lessons.filter(ls => ls.is_month);
    }
  }
};
</script>

<style lang="scss" scoped>
.feed-month-lessons {
  h5 {
    line-height: 30px;
    display: flex;
    align-items: center;

    .badge {
      border: 2px solid #fdfdfd;
      max-height: 32px;
      max-width: 32px;
      min-height: 32px;
      min-width: 32px;
      border-radius: 32px;
      font-size: 17px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 16px;
    }
  }
}
</style>
